import { DatePicker, Form, Input, Radio, SelectProps } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import FormSection from '@/components/general/FormSection';
import { FailReportWarrantyString } from '@/model/FailReport/FailReport';

interface FailReportDetailFormProps {
  ticketsSelectProps: SelectProps;
  categorySelectProps: SelectProps;
  subcategorySelectProps: SelectProps;
  editMode?: boolean;
}

const FailReportDetailForm = (props: FailReportDetailFormProps) => {
  const { t } = useTranslation();
  const { ticketsSelectProps, categorySelectProps, subcategorySelectProps, editMode } = props;

  return (
    <FormSection className="FailReportDetailForm">
      <Form.Item
        label="Ticket"
        name="ticket"
        rules={[
          {
            required: true,
            message: t('El {{field}} es requerido', { field: t('ticket') }),
          },
        ]}>
        <AntdSelect
          {...ticketsSelectProps}
          placeholder={t('Seleccione un ticket relacionado')}
          allowClear
          disabled={editMode}
        />
      </Form.Item>
      <Form.Item
        label="Categoría del reporte"
        name="category"
        rules={[
          {
            required: true,
            message: t('La {{field}} es requerida', { field: t('categoría') }),
          },
        ]}>
        <AntdSelect
          {...categorySelectProps}
          placeholder={t('Seleccione una categoría para el reporte')}
          allowClear
        />
      </Form.Item>
      {editMode && subcategorySelectProps.options && subcategorySelectProps.options.length > 0 && (
        <Form.Item
          label="Subcategoría del reporte"
          name="subcategory"
          rules={[
            {
              required: true,
              message: t('La {{field}} es requerida', { field: t('subcategoría') }),
            },
          ]}>
          <AntdSelect
            {...subcategorySelectProps}
            placeholder={t('Seleccione una subcategoría para el reporte')}
            allowClear
          />
        </Form.Item>
      )}

      <Form.Item label="Comentarios" name="comment">
        <Input.TextArea placeholder={t('Comentarios adicionales sobre el problema')} rows={4} />
      </Form.Item>
      <Form.Item
        label="En garantía"
        name="warranty"
        layout="horizontal"
        rules={[
          {
            required: true,
            message: t('El {{field}} es requerido', { field: t('Estado de garantía') }),
          },
        ]}>
        <Radio.Group>
          {Object.entries(FailReportWarrantyString).map(([value, label]) => (
            <Radio key={value} value={Number(value)}>
              {t(label)}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
      <Form.Item
        style={{ marginBottom: 0 }}
        label={t('Fecha de reporte')}
        name="report_date"
        rules={[{ required: true, message: t('Seleccione la fecha de reporte') }]}
        getValueProps={value => ({
          value: value ? dayjs(value) : undefined,
        })}>
        <DatePicker format={'L'} placeholder={t('Seleccionar una fecha')} />
      </Form.Item>
    </FormSection>
  );
};

export default FailReportDetailForm;
